import { useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PhoneInputField.css";

export default function PhoneInputField({
  value,
  changeEvent,
  addClass,
  onDialCodeStatusChange,
  disabled,
  dialCodeDisabled = false,
}) {
  // Notify parent that a default country is selected on mount
  useEffect(() => {
    if (onDialCodeStatusChange) {
      onDialCodeStatusChange(true);
    }
  }, [onDialCodeStatusChange]);

  const handleCountryChange = (country) => {
    if (onDialCodeStatusChange) {
      onDialCodeStatusChange(!!country);
    }
  };

  const handleChange = (phoneValue) => {
    // phoneValue will be in E.164 format (e.g., "+14155552671") or undefined
    changeEvent(phoneValue || "");
  };

  return (
    <div className={`phone-input-wrapper ${addClass || ""}`}>
      <PhoneInput
        defaultCountry="AU"
        value={value}
        international={true}
        // dialCodeDisabled={dialCodeDisabled}
        onChange={handleChange}
        onCountryChange={handleCountryChange}
        disabled={disabled}
        countrySelectProps={{
          disabled: dialCodeDisabled,
        }}
        placeholder="Enter phone number"
        className="custom-phone-input"
      />
    </div>
  );
}
